import { Button, Card, Checkbox, Col, Row, Space, TimePicker } from "antd";
import { renderDay, roles } from "../../../utils/constants";
import {
  addNewTimeInSchedule,
  deleteTimeSchedule,
  updateAddressSchedule,
  updateTimeSchedule,
  updateValuesSchdedule,
} from "../../Interpretes/Slices/InterpreteSlice";
import { MdAdd } from "react-icons/md";
import dayjsNormal from "dayjs";
import AutoCompleteCustom from "../../../shared/components/AutoCompleteCustom";
import { userHasLevel } from "../../../engine/AuthRoute";
import { AiFillDelete } from "react-icons/ai";
import React from "react";
import useDeviceDetect from "../../../engine/hooks/useDeviceDetect";
import Title from "antd/es/typography/Title";

export const RenderInterpretesSchedules = ({
  schedules,
  interprete = null,
}) => {
  const format = "HH:mm";

  return interprete !== null ? (
    <div>
      <Card
        title={"Disponibilités habituelles de l'interprète"}
        style={{ borderColor: "red", backgroundColor: "#FEEBEB" }}
      >
        {schedules
          .filter(f => !f.disabled)
          .map((schedule, scheduleId) => {
            return (
              <div
                key={schedule._id}
                style={{
                  marginBottom: 15,
                }}
              >
                <span>{renderDay(schedule.day)}</span>
                <br />
                {schedule.times.map((time, timeId) => {
                  return (
                    <div key={time._id}>
                      <span>
                        <b>
                          {dayjsNormal(
                            `${time.from.hour}:${time.from.minute}`,
                            format,
                          ).format(format)}
                        </b>
                        -
                        <b>
                          {dayjsNormal(
                            `${time.to.hour}:${time.to.minute}`,
                            format,
                          ).format(format)}
                        </b>
                      </span>
                      <br />
                    </div>
                  );
                })}
              </div>
            );
          })}
      </Card>
    </div>
  ) : null;
};
